/*
* @requires  ../util/websocket.js
*/

var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {

    function MonitorWebsocket(param,m,callback) {
        this.host="ws://127.0.0.1:18214/monitor";
        this.websocket=$m.createWebSocketWrapper(param,this.host);
        this.setEventCallback(m,callback)
        this.websocket.connect(param);
    }

    MonitorWebsocket.prototype.setEventCallback=function(m,callback){
        this.middlewareObj=m;
        this.websocket.setEventCallback(m,callback);
    };

    MonitorWebsocket.prototype.getVersion=function(param){
        var name="getVersion";
        var that=this;
        var p={};

        this.websocket.sendMessage({
            fun: 'GetVersion',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.version);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.getServiceStatus=function(param){
        var name="getServiceStatus";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["name"]);

        this.websocket.sendMessage({
            fun: 'GetServiceStatus',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.services);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.setService=function(param){
        var name="setService";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["name","action"]);

        this.websocket.sendMessage({
            fun: 'SetService',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.checkDigest=function(param){
        var name="checkDigest";
        var that=this;
        var p={};

        this.websocket.sendMessage({
            fun: 'CheckDigest',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.moudles);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.updateMoudle=function(param){
        var name="updateMoudle";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["name","version","url","updateAction"]);

        this.websocket.sendMessage({
            fun: 'UpdateMoudle',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.checkVersion=function(param){
        var name="checkVersion";
        var that=this;
        var p={};

        this.websocket.sendMessage({
            fun: 'CheckVersion',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.version);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };


    MonitorWebsocket.prototype.update=function(param){
        var name="update";
        var that=this;
        var p={};

        this.websocket.sendMessage({
            fun: 'Update',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.updated);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.checkCom=function(param){
        var name="checkCom";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["name"]);

        this.websocket.sendMessage({
            fun: 'CheckCom',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.checkMoudle=function(param){
        var name="checkMoudle";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["name"]);

        this.websocket.sendMessage({
            fun: 'CheckMoudle',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.result);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.repairMoudle=function(param){
        var name="repairMoudle";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["name","type"]);

        this.websocket.sendMessage({
            fun: 'RepairMoudle',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.restartMonitor=function(param){
        var name="restartMonitor";
        var that=this;
        var p={};

        this.websocket.sendMessage({
            fun: 'RestartMonitor',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.setValue=function(param){
        var name="setValue";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["group","key","value","longKeep"]);

        this.websocket.sendMessage({
            fun: 'SetValue',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.getValue=function(param){
        var name="getValue";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["group","key"]);

        this.websocket.sendMessage({
            fun: 'GetValue',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.value);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.openBrowser=function(param){
        var name="openBrowser";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["url","type"]);

        this.websocket.sendMessage({
            fun: 'OpenBrowser',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.showNotification=function(param){
        var name="showNotification";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["type","title","textMessage","imageMessage","actions","option"]);

        this.websocket.sendMessage({
            fun: 'ShowNotification',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.config=function(param){
        var name="config";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["url","projectId","updateNow"]);

        this.websocket.sendMessage({
            fun: 'Config',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.openAssistor=function(param){
        var name="openAssistor";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["name","url","width","height","enableQuit","pageName","assistorName","debug","title","front"]);

        this.websocket.sendMessage({
            fun: 'OpenAssistor',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.getCertHistory=function(param){
        var name="getCertHistory";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,[]);

        this.websocket.sendMessage({
            fun: 'GetCertHistory',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.history);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.removeCertHistory=function(param){
        var name="removeCertHistory";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["certId"]);

        this.websocket.sendMessage({
            fun: 'RemoveCertHistory',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.getPage=function(param){
        var name="getPage";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,[]);

        this.websocket.sendMessage({
            fun: 'GetPage',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.pageInfo);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.setPage=function(param){
        var name="setPage";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["pageName"]);

        this.websocket.sendMessage({
            fun: 'SetPage',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.p11Call=function(param){
        var name="p11Call";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["method","param"]);

        this.websocket.sendMessage({
            fun: 'P11Call',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.findProcess=function(param){
        var name="findProcess";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["processName"]);

        this.websocket.sendMessage({
            fun: 'FindProcess',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.find);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.openProcess=function(param){
        var name="openProcess";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["moudle","path","params"]);

        this.websocket.sendMessage({
            fun: 'OpenProcess',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.requireMoudle=function(param){
        var name="requireMoudle";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["moudles","appName"]);

        this.websocket.sendMessage({
            fun: 'RequireMoudle',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.getFilePath=function(param){
        var name="getFilePath";
        var that=this;
        var p={};
        $m.util.setAttrs(p,param,["name","newFilePattern","subDir"]);

        this.websocket.sendMessage({
            fun: 'GetFilePath',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.path);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    MonitorWebsocket.prototype.close=function(){
        this.websocket.close()
    };

    $m.MonitorWebsocket=MonitorWebsocket;

})(HebcaMiddleware);
